import { QueryClient } from "@tanstack/react-query";

import { logOnDev } from "@/services/axios/interceptors/response";

import { PusherAllEventData } from "../../types";
import { baseOrganisationChannelUpdateFn } from "./base-organisation-channel-update-fn";

export const organisationChannelUpdateAllFn = (
  queryClient: QueryClient,
  data: PusherAllEventData
) => {
  logOnDev("[‼️][UPDATE ALL EVENT]", data);

  data.forEach(event => baseOrganisationChannelUpdateFn(queryClient, event));
};
